export const selectEventDetails = (state) => state.eventDetails; //the same name of the store
